import React, { useState, useEffect, useRef } from "react";

import { getComponentValue, setComponentValue } from "../tab_options/settings/Config";

function DateTime(props) {
    let settings = JSON.parse(localStorage.getItem("settings"));
    const days = {
        es: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
        us: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    };
    const [lang, setLang] = useState(props.lang);
    const [seconds, setSeconds] = useState(0);
    const interval = useRef(null);
    const [date, setDate] = useState(getSystemDate(getComponentValue("formatDate")));

    const [timeFormat, setTimeFormat] = useState(getSystemTimeFormat(getComponentValue("formatTime")));
    const [time, setTime] = useState(getSystemTime(getComponentValue("formatTime")));

    function getSystemTime(format) {
        let hour = new Date().getHours();
        let min = new Date().getMinutes();
        if (!format && hour > 12) {
            hour -= 12;
        }
        if (hour < 10) {
            hour = "0" + hour;
        }
        if (min < 10) {
            min = "0" + min;
        }
        return hour + ":" + min;
    }

    function getSystemTimeFormat(format) {
        let hour = new Date().getHours();
        if (!format) {
            if (hour > 12) {
                return "PM";
            } else {
                return "AM";
            }
        } else {
            return null;
        }
    }

    function getSystemDate(format) {
        if (format === "mm.dd.yyyy") {
            return (
                `${getNameDay(new Date().getDay())} ${new Date().getMonth() + 1}.${new Date().getDate()}.${new Date().getFullYear()}`
            );
        } else if (format === "yyyy.mm.dd") {
            return (
                `${getNameDay(new Date().getDay())} ${new Date().getFullYear()}.${new Date().getMonth() + 1}.${new Date().getDate()}`
            );
        } else {
            return (
                `${getNameDay(new Date().getDay())} ${new Date().getDate()}.${new Date().getMonth() + 1}.${new Date().getFullYear()}`
            );
        }
    }

    function getNameDay(index) {
        if (index >= 0 && index <= 6) {
            return days[lang][index];
        }
    }

    function onChangeTimeFormat() {
        settings = setComponentValue("formatTime", null, "switch");
        localStorage.setItem("settings", JSON.stringify(settings));
        setTimeFormat(getSystemTimeFormat(getComponentValue("formatTime")));
        setTime(getSystemTime(getComponentValue("formatTime")));
        setDate(getSystemDate(getComponentValue("formatDate")));
    }

    useEffect(() => {
        setLang(props.lang);
        settings = JSON.parse(localStorage.getItem("settings"));
        setTimeFormat(getSystemTimeFormat(getComponentValue("formatTime")));
        setTime(getSystemTime(getComponentValue("formatTime")));
        setDate(getSystemDate(getComponentValue("formatDate")));
        if (interval.current === null) {
            startCounter();
        }
    }, [seconds])

    const startCounter = () => interval.current = setInterval(() => {
        setSeconds(prevState => prevState + 1)
    }, 500)

    return (
        <div className="date-time" title={(lang === "es") ? "Cambiar formato de hora (12h o 24h)" : "Change Time Format (12h or 24h)"} onClick={onChangeTimeFormat}>
            <p className="time">{time}<span className="time-format">{timeFormat}</span></p>
            <p className="date">{date}</p>
        </div>
    );
}

export default DateTime;